import Axios from "axios"
import SHA256 from 'crypto-js/sha256'

//urls
const axios = Axios.create({
    baseURL:process.env.VUE_APP_API+'/api/'
})
const axiosAdmin = Axios.create({
    baseURL:process.env.VUE_APP_API+'/admin/'
})

let actions = {
    async getServiceSuppliers({ state }){
        const data = {
            token: state.token,
            restaurant_id: state.restaurant_id
        }
        const res = await axios.post('servicesupplier/list', data)
        if(res.data.ok){
            return res.data.data
        } else {
            throw res.data.error
        }
    },
    getTags({commit}){
        return new Promise(async (resolve,reject)=>{
            try {
                let res = await axios.get(`getsearchtags`)
                
                if(res.data.ok){
                    commit('SET_TAGS',res.data.data)
                }
                resolve()
            } catch (error) {
                reject(error)
                console.log(error);
            }
        })
    },
    getPayments({commit},payload){
        return new Promise(async (resolve,reject)=>{
            let {id,pagination}=payload
            
            let url = `/getPayments/${id}`

            const { sortBy, descending, page, rowsPerPage } = pagination
            const offset = (page*rowsPerPage) - rowsPerPage

            url += `?limit=${rowsPerPage}&offset=${offset}`

            try {
                let res = await Axios.get(url)
                if (sortBy) {
                    res.data.data = res.data.data.sort((a, b) => {
                        const sortA = a[sortBy]
                        const sortB = b[sortBy]
        
                        if (descending) {
                        if (sortA < sortB) return 1
                        if (sortA > sortB) return -1
                        return 0
                        } else {
                        if (sortA < sortB) return -1
                        if (sortA > sortB) return 1
                        return 0
                        }
                    })
                }

                commit('SET_PAYMENTS',res.data)
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    },
    fetchRestaurant({commit,dispatch,state},skipCommits){
        return new Promise(async (resolve,reject)=>{
            try {
                if(!state.restaurant_id){
                    reject('permission denied')
                }
                const url = `readrestaurant?restaurant_id=${state.restaurant_id}`
                const data = {token:state.token}
                let res = await axiosAdmin.post(url,data)
                if(res.data.ok){
                    commit('FETCH_RESTAURANT', res.data.data)
                    
                    if(!skipCommits){
                    let common = {
                            socialplaceprime_id:state.restaurant_id,
                        origin:"webapp"
                    }
                        
                    commit('SET_COMMON',common)
                    commit('SET_TYPE', null)
                    await dispatch('fetchMenu')
                    }
                    resolve(res.data.data)
                }else{
                    reject(res.data.error)
                }
            } catch (error) {
                console.log(error)
                reject(error)   
            }
        })
    },
    createRestaurant({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    cpf:'',
                    recieve_emails:true,
                    restaurantname:payload.restaurantname,
                    managername:payload.managername,
                    password:SHA256(payload.password).toString(),
                    email:payload.email,
                    tag_default:payload.tag._id,
                    default_phone : '0'+payload.phone,
                    phone : '0'+payload.phone,
                    whatsapp_number : '55'+payload.phone,
                    tags:[payload.tag.tag,"todos os estabelecimentos"],
                    cidade_id:payload.city,
                    uf_id:payload.state,
                    ifood:payload.ifood
                }
                if(payload.photo != ""){
                    data.photo = payload.photo
                }
                if(payload.salesman){
                    data.salesman = payload.salesman                    
                }
                let res = await axiosAdmin.post('createmanager',data)
                if(res.data.ok){
                    commit('FETCH_USER', res.data.data)
                    commit('FETCH_RESTAURANT',state.user.restaurant_data)
                    commit('SET_TOKEN', res.data.data.token)
                }else{
                    commit('SET_AUTH_ERROR', res.data.error)
                    commit('SET_CONNECTION_ERROR', true)
                }
                resolve(res.data)
            } catch (error) {
                reject(error)
            }
        })
    },
    updateRestaurant({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                if(state.token){
                    const data = {
                        ...state.common,
                        token:state.token,
                        cnpj : payload.cnpj,
                        razao_social : payload.razao_social,
                        inscricao_municipal : payload.inscricao_municipal,
                        default_phone : '0'+payload.phone,
                        phone : '0'+payload.phone,
                        whatsapp_number : '55'+payload.phone,
                        default_email : payload.email,
                        support_email : payload.email,
                        default_address : payload.address,
                        default_address_number : payload.number,
                        default_address_district : payload.district,
                        default_address_cmplt : payload.cmplt,
                        default_address_cep : payload.cep,
                        default_address_state : payload.state,
                        default_address_city : payload.city,
                        restaurant_id : state.restaurant_id,
                    }
                    let res = await axiosAdmin.post('updaterestaurant',data)
                    if(res.data.ok){
                        dispatch('fetchRestaurant')
                        resolve(res.data)
                    }else{
                        throw res.data.error
                    }
                }else{
                    throw 'unauthorized'
                }
            } catch (error) {
                reject(error)
            }

        })
    },
    modifyRestaurant({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                if(state.token){
                    const data = {
                        ...state.common,
                        ...payload,
                        restaurant_id : state.restaurant_id,
                        token:state.token,
                    }
                    let res = await axiosAdmin.post('updaterestaurant',data)
                    if(res.data.ok){
                        await dispatch('fetchRestaurant',{skipCommits:true})
                        resolve(res.data)
                    }else{
                        throw res.data.error
                    }
                }else{
                    throw 'unauthorized'
                }
            } catch (error) {
                reject(error)
            }

        })
    },
    createType({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('addedittype',data)
                if(res.data.ok){
                    dispatch("fetchMenu")
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                }
                resolve(res.data)
            } catch (error) {
                reject(error)
            }
        })
    },
    deleteType({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    token:state.token,
                    type_id:payload
                }
                let res = await axiosAdmin.post('removetype',data)
                if(res.data.ok){
                    await dispatch("fetchMenu")
                    commit('FETCH_TYPE',state.menu[0])
                    dispatch('fetchProducts')
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                }
                resolve(res.data)
            } catch (error) {
                reject(error)
            }
        })
    },
    getCategories(){
        return axios.get('v2/getcategoriaproduto')
    },
    linkrestaurant({state}){
        const data = {
            token:state.token,
            restaurant_id:state.restaurant_id
        }
        return axiosAdmin.post('linkrestaurant',data)
    },
    subscription({state},{code,price}){
        const data = {
            token:state.token,
            restaurant_id:state.restaurant_id,
            plan:code,
            price:Number.parseFloat(price)
        }
        return axiosAdmin.post('subscription',data)
    },
    setMenu({commit,dispatch,state},type){
        return new Promise(async (resolve,reject)=>{
            let typeSelected = state.menu.find(m=>m.name_search==type.toUpperCase())
            if(typeSelected){
                commit('SET_TYPE',typeSelected)
                try {
                    const res = await dispatch('getSubtypes',typeSelected._id)
                    if(res.data.ok){
                        commit('SET_SUBTYPES',res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                resolve(true)
                } catch (error) {
                    
                }
            }else{
                reject("Categoria não encontrada")
            }
        })
    },
    importProducts({commit,dispatch,state},payload){
        const data = {
            ...state.common,
            restaurant: state.restaurant_id,
            ...payload,
            operacao:'estoque',
            token:state.token
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('createproductbatch', data)
                .then(async res => {
                    if(res.data.ok){
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
                    
            })
        })
    },
    fetchProducts({commit,dispatch,state},payload){
        if(!payload){
            payload = {
                skipCommit:false
            }
        }
        let data = {
            ...state.common,
            restaurant_id: payload.restaurant_id || state.restaurant_id,
            search: payload.search || state.search,
            ...state.filter,
            subtype: state.subtype,
            token:state.token,
            page:state.products.page || 1,
            page_length:state.products.limit || 30,
            order_column:state.products.order_column,
            order_dir:state.products.order_dir
        }
        if(state.typeSelected && !payload.skipCommit){
            if(state.typeSelected.highlight){
                data.highlight = true
            }else{
                data.type_id = state.typeSelected.type_id
            }
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('readproduct', data)
                .then(res => {
                    if(res.data.ok){
                        if(!payload.skipCommit){
                            commit('FETCH_PRODUCTS', res.data.data)
                        }
                        
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
                    
            })
        })
    },
    fetchProduct({commit,dispatch,state},{code}){
        return new Promise((resolve,reject)=>{
            let data = {
                ...state.common,
                restaurant_id: state.restaurant_id,
                product_id:"",
                code:code
            }
            axios.post('getproductnotoken', data)
                .then(res => {
                    if(res.data.ok){
                        let product = res.data.data                        
                        if(product){
                            commit('FETCH_PRODUCT',product)
                        }else{
                            commit('FETCH_PRODUCT',null)
                        }
                        resolve()
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
                    
            })
        })
    },
    createProduct({commit,dispatch,state},payload){
        const data = {
            ...state.common,
            ...payload,
            restaurant: state.restaurant_id,
            token: state.token
        }
        if(typeof data.price === "string")
            data.price = data.price.replace(".","").replace(",",".")
        if(typeof data.regular_price === "string")
            data.regular_price = data.regular_price.replace(".","").replace(",",".")
        if(typeof data.original_price === "string")
            data.original_price = data.original_price.replace(".","").replace(",",".")
        if(typeof data.costs === "string")
            data.costs = data.costs.replace(".","").replace(",",".")
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('createproduct',data)
                .then(res => {
                    if(res.data.ok){
                        dispatch('fetchProducts')
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
                    
            })
        })
    },
    fetchCombo({commit,dispatch,state},id){
        const data = {
            ...state.common,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        if(id){
            data.combolist_id = id
            data.combosession = '1'
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('readcombolist',data)
                .then(res => {
                    if(res.data.ok){
                        if(id){
                            console.log(res.data.data.combosession_list_data);
                            
                            const {combosession_list_data} = res.data.data
                            const list = []
                            Object.keys(combosession_list_data).forEach(v=>list[combosession_list_data[v].display_order-1] = v)
                            res.data.data.combosession_list = list
                        }
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
            })
        })
    },
    reprocessPizza({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('pizza/reprocess',data)
                if(res.data.ok){
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    updatePizzaConfig({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('pizza/config',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    await dispatch("fetchPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    fetchPizza({commit,dispatch,state}){
        const data = {
            ...state.common,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('pizza/alldata',data)
                .then(res => {
                    if(res.data.ok){
                        commit("FETCH_PIZZA",res.data.data)
                        commit('FETCH_SIZES',res.data.data.tamanhos)
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
            })
        })
    },
    fetchPizzaSize({commit,dispatch,state}){     
        const data = {
            ...state.common,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('pizza/tamanhos',data)
                .then(res => {
                    if(res.data.ok){
                        commit('FETCH_SIZES',res.data.data)
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
            })
        })
    },
    addeditPizzaSize({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    tamanho_id:payload._id||"",
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(typeof data.price === "string"){
                    data.price = data.price.replace(".","")
                    data.price = data.price.replace(",",".")
                }
                let res = await axiosAdmin.post('pizza/addedittamanho',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    removePizzaSize({commit,dispatch,state},id){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    tamanho_id:id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(typeof data.price === "string"){
                    data.price = data.price.replace(".","")
                    data.price = data.price.replace(",",".")
                }
                let res = await axiosAdmin.post('pizza/deltamanho',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    fetchPizzaEdge({commit,dispatch,state}){
        const data = {
            ...state.common,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('pizza/bordas',data)
                .then(res => {
                    if(res.data.ok){
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
            })
        })
    },
    createPizzaEdge({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(typeof data.price === "string"){
                    data.price = data.price.replace(".","")
                    data.price = data.price.replace(",",".")
                }
                let res = await axiosAdmin.post('pizza/createborda',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    updatePizzaEdge({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    borda_id:payload._id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(typeof data.price === "string"){
                    data.price = data.price.replace(".","")
                    data.price = data.price.replace(",",".")
                }
                let res = await axiosAdmin.post('pizza/updateborda',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    removePizzaEdge({commit,dispatch,state},id){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    borda_id:id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('pizza/delborda',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    fetchPizzaFlavor({commit,dispatch,state}){
        const data = {
            ...state.common,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('pizza/recheios',data)
                .then(res => {
                    if(res.data.ok){
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
            })
        })
    },
    createPizzaFlavor({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                Object.keys(data.price_list).forEach(v=>{
                    if(typeof data.price_list[v] === "string"){
                        data.price_list[v] = data.price_list[v].replace(".","").replace(",",".")
                    }
                })
                let res = await axiosAdmin.post('pizza/createrecheio',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    updatePizzaFlavor({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    recheio_id:payload._id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                Object.keys(data.price_list).forEach(v=>{
                    if(typeof data.price_list[v] === "string"){
                        data.price_list[v] = data.price_list[v].replace(".","").replace(",",".")
                    }
                })
                let res = await axiosAdmin.post('pizza/updaterecheio',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    removePizzaFlavor({commit,dispatch,state},id){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    recheio_id:id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('pizza/delrecheio',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    fetchPizzaDough({commit,dispatch,state}){
        const data = {
            ...state.common,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('pizza/massas',data)
                .then(res => {
                    if(res.data.ok){
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
            })
        })
    },
    createPizzaDough({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(typeof data.price === "string"){
                    data.price = data.price.replace(".","")
                    data.price = data.price.replace(",",".")
                }
                let res = await axiosAdmin.post('pizza/createmassa',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    updatePizzaDough({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    massa_id:payload._id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(typeof data.price === "string"){
                    data.price = data.price.replace(".","")
                    data.price = data.price.replace(",",".")
                }
                let res = await axiosAdmin.post('pizza/updatemassa',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    removePizzaDough({commit,dispatch,state},id){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    massa_id:id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('pizza/delmassa',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    togglePizzaStatus({commit, state, dispatch},{id, status}){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    recheio_list_enabled: [],
                    recheio_list_disabled: [],
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(status){
                    data.recheio_list_enabled.push(id)
                } else {
                    data.recheio_list_disabled.push(id)
                }
                let res = await axiosAdmin.post('pizza/updaterecheiostatus',data)
                if(res.data.ok){
                    await dispatch("reprocessPizza")
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    fetchSession({commit,dispatch,state},id){
        
        const data = {
            ...state.common,
            combosession_id:id,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('readcombosession',data)
                .then(res => {
                    if(res.data.ok){
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
            })
        })
    },
    addeditCombo({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    combolist_id:payload._id||"",
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('addeditcombolist',data)
                if(res.data.ok){
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    removeCombo({commit,dispatch,state},id){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    combolist_id:id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('removecombolist',data)
                if(res.data.ok){
                    resolve(res.data.data)
                }else{
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    removeSession({commit,dispatch,state},id){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    combosession_id:id,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                let res = await axiosAdmin.post('removeproductcombosession',data)
                if(res.data.ok){
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    addeditSession({commit,dispatch,state},payload){
        return new Promise(async (resolve,reject)=>{
            try {
                let data = {
                    ...state.common,
                    ...payload,
                    restaurant_id: state.restaurant_id,
                    token:state.token,
                }
                if(!data.combosession_id)
                    data.combosession_id = ""
                let res = await axiosAdmin.post('addeditcombosession',data)
                if(res.data.ok){
                    resolve(res.data.data)
                }else{
                    commit('SET_CONNECTION_ERROR', true)
                    reject(res.data.error)
                }
            } catch (error) {
                reject(error)
            }
        })
    },
    generateCode({state,commit}){
        return new Promise((resolve,reject)=>{
            const data={
                ...state.common,
                token:state.token,
                restaurant_id:state.restaurant_id
            }
            axiosAdmin.post('getnextproductcode',data)
                .then(res => {
                    if(res.data.ok){
                        resolve(res.data.code)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
                    
            })
        })
    },
    updateProduct({commit, dispatch, state},payload){
        const data = {
            ...state.common,
            ...payload,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        if(typeof data.price === "string")
            data.price = data.price.replace(".","").replace(",",".")
        if(typeof data.regular_price === "string")
            data.regular_price = data.regular_price.replace(".","").replace(",",".")
        if(typeof data.original_price === "string")
            data.original_price = data.original_price.replace(".","").replace(",",".")
        if(typeof data.costs === "string")
            data.costs = data.costs.replace(".","").replace(",",".")
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('updateproduct',data)
                .then(res => {
                    if(res.data.ok){
                        dispatch('fetchProducts')
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true) 
            })
        })
    },
    updateProducts({commit, dispatch, state},payload){
        const data = {
            ...state.common,
            ...payload,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        if(payload.product_list_id == "*"){
            data.search = {
                search: state.search,
                ...state.filter,
                subtype: state.subtype
            }
            if(state.typeSelected){
                data.search.type_id = state.typeSelected.type_id
            }
        }
        if(typeof data.price === "string")
            data.price = data.price.replace(".","").replace(",",".")
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('updateproductlist',data)
                .then(res => {
                    if(res.data.ok){
                        dispatch('fetchProducts')
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true) 
            })
        })
    },
    alterStatusProducts({commit, dispatch, state},payload){
        const data = {
            ...state.common,
            ...payload,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        if(payload.product_id == "*"){
            data.search = {
                search: state.search,
                ...state.filter,
                subtype: state.subtype
            }
            if(state.typeSelected){
                data.search.type_id = state.typeSelected.type_id
            }
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('alterstatusproduct',data)
                .then(res => {
                    if(res.data.ok){
                        dispatch('fetchProducts')
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true) 
            })
        })
    },
    deleteProduct({dispatch,state},product){
        const data = {
            ...state.common,
            product_id:product,
            restaurant_id: state.restaurant_id,
            token: state.token
        }
        if(data.product_id == "*"){
            data.search = {
                search: state.search,
                ...state.filter,
                subtype: state.subtype
            }
            if(state.typeSelected){
                data.search.type_id = state.typeSelected.type_id
            }
        }
        return new Promise((resolve,reject)=>{
            axiosAdmin.post('deleteproduct',data)
                .then(res => {
                    if(res.data.ok){
                        dispatch('fetchProducts')
                        resolve(res.data.data)
                    }else{
                        reject(res.data.error)
                    }
                }).catch(err => {
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
                    
            })
        })
    },
    fetchMenu({commit,dispatch,state}){
        return new Promise((resolve,reject)=>{
            let data = {
                ...state.common,
                restaurant_id: state.restaurant_id,
                token:state.token,
                type:'',
                subtype:'',
                search: state.search
            }        
            axiosAdmin.post('gettype', data)
                .then(res => {
                    if(res.data.ok){
                        commit('FETCH_MENU', res.data.data)
                        resolve()
                    }else{
                        alert(res.data.error)
                        reject()
                    }
                }).catch(err => {
                    console.log(err);
                    commit('SET_CONNECTION_ERROR', true)
                    reject()
            })
        })
    },
    getSubtypes({state},type_id){
        let data = {
            ...state.common,
            token:state.token,
            type_id:type_id,
        }        
        return axiosAdmin.post('getsubtype', data)
    },
    createSubtype({state},payload){
        let data = {
            ...state.common,
            ...payload,
            description:'',
            restaurant_id: state.restaurant_id,
            token:state.token,
        }
        return axiosAdmin.post('addeditsubtype',data)
    },
    removeSubtype({state},payload){
        let data = {
            ...state.common,
            ...payload,
            token:state.token,
        }
        return axiosAdmin.post('removesubtype',data)
    },
    doLogin({dispatch,commit,state},{email,password}){
        let data = {
            ...state.common,
            email,
            password:SHA256(password).toString(),
            object_type:0,
            facebook_login:""
        }
        return new Promise(async (resolve,reject)=>{
            try {
                const res = await axios.post('login',data)
                if(res.data.ok){
                    commit('FETCH_USER', res.data.data)
                    commit('SET_TOKEN', res.data.data.token)
                    await dispatch('fetchRestaurant')
                }
                resolve(res.data)
            } catch (error) {
                reject(error)
            }
        })
    },
    updateUser({commit,state},{username,email,phone,cpf}){
        if(state.token){
            let token = state.token
            let common = state.common
            let data = {
                ...common,
                token,
                username,
                email,
                phone,
                cpf
            }
            return axios.post('updateuser',data)
        }
    },
    resetPassword({commit,state},password){
        if(state.token){
            let token = state.token
            let common = state.common
            let data = {
                ...common,
                token,
                password:SHA256(password).toString()
            }
            return axios.post('updateuser',data)
        }
    },
    doRegister({commit,dispatch,state},{fullName,password,phone}){
        let data = {
            ...state.common,
            username:fullName,
            phone:55+phone,
            password:SHA256(password).toString(),
        }
        return new Promise((resolve, reject)=>{
            axios.post('createuser',data)
                .then(res => {
                    if(res.data.ok){
                        commit('TOGGLE_REGISTER_DIALOG')
                        commit('PHONE_VALIDATION', res.data.data.phone)
                        commit('SET_TOKEN', res.data.data.token)
                        dispatch('sendPin')
                    }
                    resolve(res.data)
                }).catch(err =>{
                    console.log(err);
                    reject(err)
                    commit('SET_CONNECTION_ERROR', true)
                })
        })
    },
    refreshUser({commit,dispatch,state}){
        if(state.token != null){
            let data = {
                ...state.common,
                token: state.token,
            }
            axios.post('loginexternal',data)
                .then(res => {
                    if(res.data.ok){
                        if(res.data.data.phone_validation.validated_phone){
                            commit('FETCH_USER', res.data.data)
                        }else{
                            commit('PHONE_VALIDATION', res.data.data.phone_validation.validation_number)
                            dispatch('sendPin')
                        }
                    }
                }).catch(err =>{
                    commit('SET_CONNECTION_ERROR', true)
                })
        }else{
            dispatch('logout')
        }
    },
    logout({commit}){
        commit('LOGOUT')
        commit('CLEAR_CART')
        commit('CLEAR_RESPONSE')
        commit('CLEAR_CART_PRODUCTS')
        commit('CLEAR_ORDER')
        localStorage.clear()
    },
    viaCep({commit},cep){
        return new Promise((resolve,reject)=>{
            axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    },
    getStates({commit}){
        return new Promise(async(resolve)=>{
            let res = await axios.get(`https://api.socialplace.com.br/admin/uf`)
            if(res.data.ok){
                commit('SET_STATES',res.data.data)
                resolve()
            }else{
                throw 'something went wrong'
            }
        })
    },
    getCities({commit},uf){
        //admin/cidadeuf?uf_id
        return new Promise(async (resolve,reject)=>{
            let res = await axios.get(`https://api.socialplace.com.br/admin/cidadeuf?uf_id=${uf}`)
            if(res.data.ok){
                commit('SET_CITIES',res.data.data)
                resolve()
            }else{
                throw 'something went wrong'
            }
        })

    },
    getDistricts({},city){
        //api/getcitydistrict?cidade_id
        return axios.get(`getcitydistrict?cidade_id=${city}`)
    },
    getSalesman({},code){
        return axiosAdmin.get(`searchsalesman?code=${code}`)
    }
}

export default actions